import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  Input,
  Label,
} from "reactstrap"

// Redux
import { connect } from "react-redux"
import { withRouter, Link } from "react-router-dom"

// action
import {
  userForgetPassword,
  getVendorsForUser,
  resetForgetPassword,
  resetVendors,
} from "../../store/actions"
// import { getVendors } from "store/clients/actions"

// import images
import profile from "../../assets/images/profile-img.png"
import logo from "../../assets/images/logo.svg"
import { LOCAL_STORAGE_TAGS } from "constants/index"
import Select from "react-select"
import { SaveButton } from "components/Buttons"

const ForgetPasswordPage = props => {
  const [emailValue, setEmailValue] = useState("")
  const [vendorValue, setVendorValue] = useState(null)

  useEffect(() => {
    return () => {
      props.resetForgetPassword()
      localStorage.removeItem(LOCAL_STORAGE_TAGS.CLIENTS_TAG)
      props.resetVendors()
    }
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>Forget Password </title>
      </MetaTags>

      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs={7}>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset your password!</h5>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img src={profile} alt="" className="img-fluid" />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {!!props?.userVendorListFetchError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {props?.userVendorListFetchError?.data?.error
                          ?.email[0] || "Please try again"}
                      </Alert>
                    ) : null}

                    {props.forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {props.forgetSuccessMsg}
                      </Alert>
                    ) : null}

                    <Row>
                      <Col>
                        <Label for="email">Email</Label>
                        <Input
                          value={emailValue}
                          onChange={event =>
                            setEmailValue(event?.target?.value)
                          }
                          onBlur={event => {
                            if (event?.target?.value) {
                              setVendorValue(null)
                              props.getVendorsForUser({
                                email: event?.target?.value,
                              })
                            }
                          }}
                          type="email"
                          id="email"
                          className="form-control"
                          placeholder="Email"
                        />
                      </Col>
                    </Row>

                    <Row className="mt-3">
                      <Col>
                        <Label for="vendor">Company</Label>
                        <Select
                          value={vendorValue}
                          inputId="vendor"
                          placeholder="Select company"
                          onChange={v => {
                            setVendorValue(v)
                          }}
                          options={props?.userVendorList?.map(vendor => ({
                            value: vendor?.id,
                            label: vendor?.name,
                          }))}
                          menuPortalTarget={document.body}
                          styles={{
                            menuPortal: provided => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                            menu: provided => ({
                              ...provided,
                              zIndex: 9999,
                            }),
                          }}
                          isDisabled={
                            !!props?.userVendorListFetchError || !emailValue
                          }
                        />
                      </Col>
                    </Row>

                    <Row className="d-flex justify-content-center mt-3">
                      <Col xs="auto">
                        <SaveButton
                          type="button"
                          content="Reset"
                          color="primary"
                          disabled={!vendorValue}
                          onClick={() =>
                            props.userForgetPassword({
                              email: emailValue,
                              vendor_id: vendorValue?.value,
                            })
                          }
                          loading={props?.loading}
                        />
                      </Col>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Go back to{" "}
                  <Link to="login" className="font-weight-medium text-primary">
                    Login
                  </Link>{" "}
                </p>
                <p>
                  © {new Date().getFullYear()} Skote. Crafted with{" "}
                  <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  forgetError: PropTypes.any,
  forgetSuccessMsg: PropTypes.any,
  history: PropTypes.object,
  userForgetPassword: PropTypes.func,
}

const mapStateToProps = state => {
  const { forgetError, forgetSuccessMsg, loading } = state.ForgetPassword
  const { userVendorList, userVendorListFetchError } = state.clients
  return {
    forgetError,
    forgetSuccessMsg,
    userVendorList,
    userVendorListFetchError,
    loading,
  }
}

export default withRouter(
  connect(mapStateToProps, {
    userForgetPassword,
    getVendorsForUser,
    resetForgetPassword,
    resetVendors,
  })(ForgetPasswordPage)
)
